import { useEffect, useState } from 'react'

import { browserEnvironment, startPreview } from './resource'

import type { FilePreviewProps, PreviewState } from './types'

export function usePreview(props: FilePreviewProps) {
    const [state, setState] = useState<PreviewState>({ status: 'authorizing' })
    useEffect(() => {
        const session = startPreview(props, browserEnvironment(), setState)
        return () => session.dispose()
    }, [props])
    return state
}
